
import Vue from 'vue';
import Component from 'vue-class-component';
import { ValidationObserver } from 'vee-validate/dist/types/components';
import { TYPES } from '@/core/config/Types';
import { Inject } from '@/core/di/Inject';
import { Prop } from 'vue-property-decorator';
import { Role } from '@/settings/domain/role/Role';
import VJstree from 'vue-jstree';
import { RoleFindMenuPlaneByRoleName } from '@/settings/application/uses_cases/role/search/RoleFindMenuPlaneByRoleName';
import { CreateRole } from '@/settings/application/uses_cases/role/create/CreateRole';

@Component({
  name: 'CreateNewRole',
  components: {
    VJstree
  }
})
export default class CreateNewRole extends Vue {
  @Inject(TYPES.FINDMENUPLANEBYROLENAME_ROLE)
  readonly roleFindMenuPlaneByRoleName!: RoleFindMenuPlaneByRoleName;
  @Inject(TYPES.CREATE_ROLE) readonly createRole!: CreateRole;
  //Data
  isTouched = false;
  isLoading = false;
  fullPage = true;
  roles: Role[] = [];
  formRole: Role = new Role();

  types = [
    {
      id: 1,
      name: 'ADMIN'
    },
    {
      id: 2,
      name: 'USER'
    }
  ];
  menu = [
    {
      text: 'Same but with checkboxes',
      children: [
        {
          text: 'initially selected',
          selected: true
        },
        {
          text: 'custom icon',
          icon: 'fa fa-warning icon-state-danger'
        },
        {
          text: 'initially open',
          icon: 'fa fa-folder icon-state-default',
          opened: true,
          children: [
            {
              text: 'Another node'
            }
          ]
        },
        {
          text: 'custom icon',
          icon: 'fa fa-warning icon-state-warning'
        },
        {
          text: 'disabled node',
          icon: 'fa fa-check icon-state-success',
          disabled: true
        }
      ]
    },
    {
      text: 'Same but with checkboxes',
      opened: true,
      children: [
        {
          text: 'initially selected',
          selected: true
        },
        {
          text: 'custom icon',
          icon: 'fa fa-warning icon-state-danger'
        },
        {
          text: 'initially open',
          icon: 'fa fa-folder icon-state-default',
          opened: true,
          children: [
            {
              text: 'Another node'
            }
          ]
        },
        {
          text: 'custom icon',
          icon: 'fa fa-warning icon-state-warning'
        },
        {
          text: 'disabled node',
          icon: 'fa fa-check icon-state-success',
          disabled: true
        }
      ]
    },
    {
      text: 'And wholerow selection'
    }
  ];
  selectedOptionMenu: any[] = [];
  //Prop
  @Prop() readonly activeAdd!: boolean;
  @Prop() readonly roleList!: any;
  @Prop() readonly observer!: Function;

  //Refs
  $refs!: {
    validationRole: InstanceType<typeof ValidationObserver>;
  };
  //Hook

  created() {
    this.findRoleMenuById();
    this.formRole.type = { id: 2, name: 'USER' };
  }
  findRoleMenuById() {
    this.menu = JSON.parse(localStorage.getItem('menuUser') as string);
  }
  saveForm() {
    this.mapToList(this.menu);

    if (this.formRole.menu.length > 0) {
      //fixed pyload
      this.formRole.roleType = this.formRole.type.id;
      this.formRole.roleTypeName = this.formRole.type.name;
      this.formRole.companyId = localStorage.getItem('businessId') as string;
      //end fixed

      this.createRole.execute(this.formRole).finally(() => {
        this.isLoading = false;
        this.observer(true);
      });
    }
  }

  mapToList(menu: any[]) {
    menu.forEach(item => {
      if (item.selected) this.formRole.menu.push(item);

      if (item.children) if (item.children.length > 0) this.mapToList(item.children);
    });
  }

  getValidationState({ dirty, validated, valid = null }: { dirty: any; validated: any; valid: any }) {
    return dirty || validated ? valid : null;
  }
}
